var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnomalyArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F6F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5832 7C14.5832 6.58579 14.919 6.25 15.3332 6.25H20.3332C20.7474 6.25 21.0832 6.58579 21.0832 7V12C21.0832 12.4142 20.7474 12.75 20.3332 12.75C19.919 12.75 19.5832 12.4142 19.5832 12V8.81066L15.0302 13.3637C15.0177 13.3762 15.0053 13.3885 14.9932 13.4007C14.795 13.599 14.6422 13.7519 14.4869 13.8688C13.5076 14.6058 12.1587 14.6058 11.1795 13.8688C11.0241 13.7519 10.8713 13.599 10.6732 13.4007C10.661 13.3885 10.6487 13.3762 10.6362 13.3637C10.3836 13.1111 10.311 13.0411 10.2515 12.9963C9.80637 12.6613 9.19326 12.6613 8.74813 12.9963C8.6886 13.0411 8.61604 13.1111 8.36346 13.3637L4.19683 17.5303C3.90394 17.8232 3.42907 17.8232 3.13617 17.5303C2.84328 17.2374 2.84328 16.7625 3.13617 16.4696L7.3028 12.303C7.31531 12.2905 7.32763 12.2782 7.33978 12.266C7.53797 12.0677 7.69073 11.9148 7.8461 11.7979C8.82539 11.0608 10.1742 11.0608 11.1535 11.7979C11.3089 11.9148 11.4617 12.0677 11.6598 12.266C11.672 12.2782 11.6843 12.2905 11.6968 12.303C11.9494 12.5556 12.022 12.6255 12.0815 12.6703C12.5266 13.0053 13.1397 13.0053 13.5849 12.6703C13.6444 12.6255 13.7169 12.5556 13.9695 12.303L18.5225 7.75H15.3332C14.919 7.75 14.5832 7.41421 14.5832 7Z",
    fill: "#054254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnomalyArrow);
export default __webpack_public_path__ + "static/media/anomaly-arrow.c05397aaaf3c4890a67447ed074b4092.svg";
export { ForwardRef as ReactComponent };